module.exports = __webpack_public_path__ + "img/34_30.cce461fd.png";